import { render, staticRenderFns } from "./DownloadExcelTemplate.vue?vue&type=template&id=ff568e6a&scoped=true"
import script from "./DownloadExcelTemplate.vue?vue&type=script&lang=js"
export * from "./DownloadExcelTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff568e6a",
  null
  
)

export default component.exports